import type { ClientPageKey, ProductRoute } from "../app/product-router.js";
import { NavIcon, type NavKey } from "./nav-icons.js";
import type { ReactNode } from "react";

export interface NavItem {
  key: NavKey;
  page: ClientPageKey;
  label: string;
  matches: ClientPageKey[];
}

export const navItems: NavItem[] = [
  {
    key: "clubhouse",
    page: "clubhouse",
    label: "Clubhouse",
    matches: ["clubhouse"],
  },
  {
    key: "tee-off",
    page: "tee-off",
    label: "Tee Off",
    matches: ["tee-off", "scorecard"],
  },
  {
    key: "rivalry",
    page: "rivalry",
    label: "Rivalry",
    matches: ["rivalry", "rivals"],
  },
  { key: "feed", page: "feed", label: "Feed", matches: ["feed"] },
  {
    key: "more",
    page: "more",
    label: "More",
    matches: [
      "more",
      "profile",
      "rounds",
      "trophies",
      "stats",
      "courses",
      "reviews",
      "settings",
      "admin",
      "fgl",
    ],
  },
];

/**
 * Primary navigation: a fixed transparent bottom bar on phones and a
 * sticky centered row under the header on desktop (see shell.css). While
 * a round is open, Tee Off leads straight to its scorecard.
 */
export function PrimaryNav(props: {
  route: ProductRoute;
  localOnly: boolean;
  roundOpen: boolean;
  items?: readonly NavItem[];
  renderIcon?: (name: NavKey) => ReactNode;
}): React.JSX.Element {
  const configuredItems = props.items ?? navItems;
  const items = props.localOnly
    ? configuredItems.filter((item) => item.key !== "more")
    : configuredItems;
  const teeOffTarget: ClientPageKey =
    props.localOnly || props.roundOpen ? "scorecard" : "tee-off";
  return (
    <div className="fr-nav-wrap">
      <nav className="fr-nav" aria-label="Primary">
        {items.map((item) => {
          const active = item.matches.includes(props.route.page);
          const target = item.key === "tee-off" ? teeOffTarget : item.page;
          return (
            <a
              key={item.key}
              className="fr-nav-btn"
              href={props.route.pathFor(target)}
              aria-current={active ? "page" : undefined}
              onClick={(event) => {
                event.preventDefault();
                props.route.navigate(target);
              }}
            >
              <span className="fr-nav-ic">
                {props.renderIcon ? (
                  props.renderIcon(item.key)
                ) : (
                  <NavIcon name={item.key} />
                )}
              </span>
              <span className="fr-nav-lbl">{item.label}</span>
            </a>
          );
        })}
      </nav>
    </div>
  );
}
